
(function(){
  var host = document.getElementById('md13a-sticky-template--25453838893249__md13_adv1_open_CNCqTN');
  if(!host) return;
  var el = host.querySelector('[data-md13a-countdown]');
  if(!el) return;

  var mins = parseInt(el.getAttribute('data-minutes'), 10) || 15;
  var KEY  = 'md13aDeadline-template--25453838893249__md13_adv1_open_CNCqTN';
  var end;

  try { end = parseInt(sessionStorage.getItem(KEY), 10); } catch(e){ end = null; }
  if(!end || isNaN(end) || end < Date.now()){
    end = Date.now() + mins * 60 * 1000;
    try { sessionStorage.setItem(KEY, String(end)); } catch(e){}
  }

  function pad(n){ return n < 10 ? '0' + n : '' + n; }

  function tick(){
    var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
    var m = Math.floor(left / 60);
    var s = left % 60;
    el.textContent = pad(m) + ':' + pad(s);
    if(left <= 0){ clearInterval(timer); }
  }

  tick();
  var timer = setInterval(tick, 1000);
})();

;

(function(){
  var root = document.getElementById('shopify-section-template--25453838893249__md13_adv1_mid_xLdthD');
  if(!root) return;
  var nodes = root.querySelectorAll('[data-md13a-countdown]');
  if(!nodes.length) return;

  function pad(n){ return n < 10 ? '0' + n : '' + n; }

  Array.prototype.forEach.call(nodes, function(el){
    var mins = parseInt(el.getAttribute('data-minutes'), 10) || 15;
    var KEY  = el.getAttribute('data-key') || 'md13aDeadline';
    var end;
    try { end = parseInt(sessionStorage.getItem(KEY), 10); } catch(e){ end = null; }
    if(!end || isNaN(end) || end < Date.now()){
      end = Date.now() + mins * 60 * 1000;
      try { sessionStorage.setItem(KEY, String(end)); } catch(e){}
    }
    function tick(){
      var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      el.textContent = pad(Math.floor(left / 60)) + ':' + pad(left % 60);
      if(left <= 0){ clearInterval(t); }
    }
    tick();
    var t = setInterval(tick, 1000);
  });
})();

;

(function(){
  var root = document.getElementById('shopify-section-template--25453838893249__md13_adv1_close_eeqa8A');
  if(!root) return;
  var nodes = root.querySelectorAll('[data-md13a-countdown]');
  if(!nodes.length) return;

  function pad(n){ return n < 10 ? '0' + n : '' + n; }

  Array.prototype.forEach.call(nodes, function(el){
    var mins = parseInt(el.getAttribute('data-minutes'), 10) || 15;
    var KEY  = el.getAttribute('data-key') || 'md13aDeadline';
    var end;
    try { end = parseInt(sessionStorage.getItem(KEY), 10); } catch(e){ end = null; }
    if(!end || isNaN(end) || end < Date.now()){
      end = Date.now() + mins * 60 * 1000;
      try { sessionStorage.setItem(KEY, String(end)); } catch(e){}
    }
    function tick(){
      var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      el.textContent = pad(Math.floor(left / 60)) + ':' + pad(left % 60);
      if(left <= 0){ clearInterval(t); }
    }
    tick();
    var t = setInterval(tick, 1000);
  });
})();
